import { FormControlLabel, Switch } from "@mui/material";
import { FC } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { GroupTitleTemplate } from "@ryde/controls";
import {
  BOOKING_UPLOAD_FORM_FIELDS,
  IBulkUploadBookingsForm,
} from "@ryde/shared";

import { BulkCreateBookingsCreateFieldsSectionStyled } from "./bulk-bookings.styled";

export const BulkUploadCreateFieldsSection: FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<IBulkUploadBookingsForm>();
  const { fields, update } = useFieldArray({
    control,
    name: BOOKING_UPLOAD_FORM_FIELDS.entityCreateFields,
  });

  if (fields.length === 0) {
    return null;
  }

  return (
    <BulkCreateBookingsCreateFieldsSectionStyled>
      <GroupTitleTemplate
        name="create_fields_if_not_found"
        labelTranslated={t("general.create_fields_if_not_found")}
      />
      {fields.map((field, index) => (
        <FormControlLabel
          key={field.customFieldId}
          control={
            <Switch
              checked={field.isAllow}
              onChange={() =>
                update(index, { ...field, isAllow: !field.isAllow })
              }
            />
          }
          label={field.label}
        />
      ))}
    </BulkCreateBookingsCreateFieldsSectionStyled>
  );
};
